
import React from "react";
import SpHeader from "../../../Components/mainHeader/SpHeader";
import SobTabsHeader from "../SobTabsHeader/SobTabsHeader";
import { sob_moremenu } from "../SobTabsHeader/SobMoreMenuLinks";
import { FormControl, MenuItem, OutlinedInput, Select } from "@mui/material";
import { Link } from "react-router-dom";




function SobGeneralInfo() {
    const pageNo = 0;
    const breadcrumbs = [
        { label: 'Site On Boarding', link: '' },
        { label: 'Add Existing Site', link: '/SitesOnboarding' },
        { label: 'AMKM - 03', link: '' },
    ];
 

    return (
        <div className="sobSteps_wrapper">
            <SpHeader breadcrumbs={breadcrumbs} />

            <SobTabsHeader pageNo={pageNo} sob_moremenu={sob_moremenu} />

            <div className="sobSteps_content_main">

                <div className="sobGeneralInfo pb-1">
                    <div className="sobSteps_content contentWrap">
                        <div className="row pt-3">
                            <div className="col-12 col-lg-8 box_card">
                                <div className="sobGeneralInfo_inner">
                                    <div className="sob_heading">
                                        <h2>General Information</h2>
                                    </div>
                                    <div className="row">
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Site ID<span>*</span></h4>
                                                <OutlinedInput />
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>District<span>*</span></h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select label="Select an option">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>City<span>*</span></h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Cluster</h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Belt<span>*</span></h4>
                                                <OutlinedInput />
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Geo Tag<span>*</span></h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Region<span>*</span></h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Sub Region</h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Lat.</h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1} className='label16 weight6'>Select 1</MenuItem>
                                                            <MenuItem value={2} className='label16 weight6'>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6 col-lg-4 col-xl-3  pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Long.</h4>
                                                <div className="applyFilter_box">
                                                    <FormControl className='m-0'>
                                                        <Select defaultValue="" label="Grouping">
                                                            <MenuItem value={1}>Select 1</MenuItem>
                                                            <MenuItem value={2}>Select 2</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 pb-4'>
                                            <div className="sobInfo_box">
                                                <h4>Site Address<span>*</span></h4>
                                                <div className="sobInfo_input">
                                                    <textarea name="content" id="content" cols="2" rows="2" required=""></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4">
                                <div className="row ps-1">
                                    <div className="col-12 col-lg-12">
                                        <div className="sobGeneralInfo_inner bg_gray_dark5">
                                            <div className="sob_heading">
                                                <h2> General Information </h2>
                                            </div>
                                            <div className="sob_summary_data">
                                                <table className="table st_summary_list mb-2">
                                                    <tbody>
                                                        <tr>
                                                            <th>Site ID</th>
                                                            <th>GST</th>
                                                        </tr>
                                                        <tr>
                                                            <td>District</td>
                                                            <td>Deposit</td>
                                                        </tr>
                                                        <tr>
                                                            <td>City</td>
                                                            <td>Ballon / RV</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Cluster</td>
                                                            <td>Term</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Belt</td>
                                                            <td>Payment Structure</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Geo Tag</td>
                                                            <td>Financed Amount</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Region</td>
                                                            <td>Financed Amount</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Sub Region</td>
                                                            <td>Financed Amount</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Lat</td>
                                                            <td>Financed Amount</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Long</td>
                                                            <td>Financed Amount</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Site Address</td>
                                                            <td>Blended Rate</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tf_next_reset_btn pt-3 contentWrap">
                        <Link to={'/OnboardingSearch'} className="btn btn-secondary me-2">Cancel</Link>
                        <Link to={'/SobSitesInfra'} className="btn btn-dark">Next</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SobGeneralInfo;